import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ColorPicker, Button } from '@itds/elements/index.js';
import { Colors } from '@itds/Theme';

import { Api } from '@brokerage/utils/Api';

const ThemeOptions = ({ annuity_quoter, setErrorMessage, setSuccessMessage }) => {
  const [data, setData] = useState({});

  useEffect(() => {
    if (annuity_quoter.theme_options) {
      Api.loadAnnuityQuoterThemeOptions(annuity_quoter.theme_options.id).then(response => {
        setData(response.data);
      });
    }
  }, [annuity_quoter]);

  useEffect(() => {
    return () => {
      setErrorMessage(null);
      setSuccessMessage(null);
    };
  }, []);

  const handleColorChange = color => {
    setData({ ...data, secondary_color: color.hex });
  };

  const handleSave = () => {
    Api.updateAnnuityQuoterThemeOptions(annuity_quoter.theme_options.id, data)
      .then(() => {
        setSuccessMessage('Theme Options updated successfully');
      })
      .catch(() => {
        setErrorMessage('Error saving Theme Options');
      });
  };

  return (
    <div>
      <ColorPicker
        color={{ hex: data.secondary_color || Colors.PRIMARY.hex }}
        label='Theme Color'
        onChange={handleColorChange}
      />

      <div style={{ marginTop: 30 }}>
        <Button inline={true} onClick={handleSave}>
          Save
        </Button>
      </div>
    </div>
  );
};

ThemeOptions.propTypes = {
  annuity_quoter: PropTypes.object,
  setErrorMessage: PropTypes.func,
  setSuccessMessage: PropTypes.func
};

export default ThemeOptions;
